module.exports = __webpack_public_path__ + "img/personal.25df1001.png";